var _ = require('underscore');
var $ = require('jquery');
var Core = require('../core/core.js');

class DashboardItemButton extends Core {
  _defaults() {
    return {
      target: '.js-editor',
      fields: {
        'text': '',
      }
    };
  }

  constructor(options) {
    super(options);

    this.template = `
      <div class="editor__dashboard__listcomponents__item__btn__container">
        <a href="" class="js-editor__dashboard__listcomponents__item__btn">
          <div class="editor__dashboard__listcomponents__item__btn">
            <div class="editor__dashboard__listcomponents__item__btn__text"><%- text %></div>
          </div>
        </a>
      </div>
    `;

    super.render();

    $('.js-editor__dashboard__listcomponents__item__btn', this.$el).on('click', this._btnClicked);
  }

  _btnClicked(e) {
    e.preventDefault();
    $(e.currentTarget).trigger('Cioui:DashboardListItemBtn:clicked');
  }
}
module.exports = DashboardItemButton;
